import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { VmeCommonModule } from '../../vme-common.module';
import { VMEComponentsModule } from '../../vme-components.module';
import { VmeDirectivesModule } from '../../vme-directives.module';
import { VmePipesModule } from '../../vme-pipes.module';
import { InsuranceProvidersComponent } from './insurance-providers.component';

const routes: Routes = [
  { path: '', component: InsuranceProvidersComponent, data: { title: 'Insurance Providers' } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InsuranceProvidersRoutingModule {}

@NgModule({
  imports: [
    InsuranceProvidersRoutingModule,
    VmeCommonModule,
    VmeDirectivesModule,
    VmePipesModule,
    VMEComponentsModule,
  ],
  declarations: [InsuranceProvidersComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class InsuranceProvidersModule {}
